import Icon from "@components/Icon";
import { HOME, LOGIN, PRICING, SIGNUP } from "@constants/internal-route.constant";
import { useColorMode } from "@layout/console/useColorMode";
import { ENV } from "config/ENV.config";
import { Container, Nav, Navbar } from "react-bootstrap";
import { Link, NavLink, Outlet } from "react-router-dom";
import PublicFooter from "./PublicFooter";
import { useBodyClasses } from "./useBodyClasses";

/** Signed-out Home and Pricing: AdminLTE's top-nav look, a header with no sidebar. */
const PublicLayout = () => {
  useColorMode();
  useBodyClasses("bg-body-tertiary");

  return (
    <div className="d-flex flex-column min-vh-100">
      <Navbar expand="md" collapseOnSelect className="bg-body border-bottom erp-public-nav">
        <Container fluid="xl">
          <Navbar.Brand as={Link} to={HOME}>
            <img src={ENV.brandLogo} alt={ENV.brandName} className="erp-public-nav__logo" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="erp-public-nav" />
          <Navbar.Collapse id="erp-public-nav">
            <Nav className="me-auto">
              <Nav.Link as={NavLink} to={PRICING} eventKey={PRICING}>
                Pricing
              </Nav.Link>
              {ENV.marketingUrl ? (
                <>
                  <Nav.Link href={`${ENV.marketingUrl}/about-us.php`}>About us</Nav.Link>
                  <Nav.Link href={`${ENV.marketingUrl}/contact.php`}>Contact us</Nav.Link>
                </>
              ) : null}
            </Nav>
            <div className="d-flex gap-2 py-2 py-md-0">
              <Link to={SIGNUP} className="btn btn-sm btn-outline-primary d-inline-flex align-items-center gap-1">
                <Icon icon="rocket-takeoff" /> 30-Days Trial
              </Link>
              <Link to={LOGIN} className="btn btn-sm btn-primary d-inline-flex align-items-center gap-1">
                <Icon icon="box-arrow-in-right" /> Login
              </Link>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <main className="flex-grow-1 py-4">
        <Container fluid="xl">
          <Outlet />
        </Container>
      </main>

      <footer className="border-top bg-body py-3">
        <Container fluid="xl">
          <PublicFooter />
        </Container>
      </footer>
    </div>
  );
};

export default PublicLayout;
